import OneBox from "@drift/oneplatfront";
import { business } from "./features/business/feature";
import { csldashboard } from "./features/csl/dashboard/feature";
import { csldetails } from "./features/csl/details-page/feature";
import { cslcreate } from "./features/csl/create-page/feature";
import { dashboard } from "./features/dashboard/feature";
import { details } from "./features/details/feature";
import { intermediaries } from "./features/intermediaries/feature";
import { newcustomer } from "./features/newcustomer/feature";
import { root } from "./features/root/feature";
import { demo } from "./features/demo/feature";
import { tenantSettings } from "./features/tenant/feature";
import { FF_CSL, FF_DEMO } from "./utils/feature-flags";

const { version } = require("../package.json");

const appId = process.env.REACT_APP_REGISTRY_ID;

const cslFeatures = FF_CSL ? [csldashboard, csldetails, cslcreate] : [];
const demoFeature = FF_DEMO ? [demo] : [];

OneBox.run({
    trace: "compact",
    settings: {
        one: {
            auth: {
                token: { verify: true, refresh: true }
            },
            box: {
                app: {
                    id: "998770fc-1a55-4c1b-979a-8ff5eb98f8bb"
                },
                module: {
                    name: "WORKSPACE",
                    version
                }
            },
            loading: {
                delay: 2000
            },
            layout: { title: "Customer Management" },
            login: {
                target: {
                    params: ["mode=redirect", `appId=${appId}`]
                }
            },
            i18n: {
                options: {
                    ns: ["react-sdk", "CM", "ws--ui", "ws--forms"],
                    defaultNS: "CM",
                    fallbackLng: "it",
                    expirationTime: 86400000
                }
            }
        }
    },
    features: [
        root,
        dashboard,
        details,
        business,
        newcustomer,
        tenantSettings,
        intermediaries,
        ...cslFeatures,
        ...demoFeature
    ]
}).catch(console.error);
